import { Variant } from '@material-ui/core/styles/createTypography'
import {
  Wrapper,
  WrapperExpanded,
  Title,
  ActionIndicator,
  ActionIndicatorExpanded,
  TitleWrapper,
  IconWrapper,
} from './NavigationButton.style'

interface NavigationButtonProps
  extends Omit<Partial<React.HTMLProps<HTMLButtonElement>>, 'type'> {
  icon: JSX.Element
  text: string
  isExpanded: boolean
  textVariant?: Variant
  isCurrentLocation: boolean
  onClick: () => void
  actionRequired?: boolean
}

const NavigationButton = ({
  icon,
  text,
  isExpanded,
  textVariant = 'body1',
  isCurrentLocation,
  actionRequired = false,
  onClick,
  ...props
}: NavigationButtonProps) => {
  const WrapperComponent = isExpanded ? WrapperExpanded : Wrapper
  return (
    <WrapperComponent onClick={onClick} isActive={isCurrentLocation} {...props}>
      {isExpanded ? <IconWrapper>{icon}</IconWrapper> : icon}
      <ActionIndicator hide={!actionRequired || isExpanded} />
      {isExpanded && text && (
        <TitleWrapper>
          <Title isExpanded={isExpanded} variant={textVariant}>
            {text}
          </Title>
          {actionRequired && <ActionIndicatorExpanded />}
        </TitleWrapper>
      )}
    </WrapperComponent>
  )
}

export default NavigationButton
